import { Component, EventEmitter, Output, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes } from 'ngx-uploader';
import { CONFIG } from '../../../../config';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/app-state';
import { DomSanitizer } from "@angular/platform-browser";
import { CommerceService } from '../../../service/app/commerce.service';

@Component({
  selector: 'app-uploader-billing',
  templateUrl: './uploader-billing.component.html',
  styleUrls: ['./uploader-billing.component.scss']
})
export class UploaderBillingComponent implements OnInit, OnChanges {

  //@Input() D;
  @Input() titulo = '';
  @Input() tpvInfo: any;
  @Input() group = 'none';

  formData: FormData;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  fileIcon = '';
  fileStatus = '';
  data: any = null;
  archivos = [];
  cantidad = 0;
  current = 0;
  pdfUrl;
  label = 'Salvado con éxito...'
  @Output()
  onComplete = new EventEmitter<any>();


  constructor(private store: Store<AppState>, private commerceService: CommerceService, private domSanitizer: DomSanitizer) {
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to ngx-uploader
    this.humanizeBytes = humanizeBytes;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ID) {
      if (changes.ID.currentValue > 0) {
        this.loadfiles();
      }
    }
  }

  move(dir) {
    if (dir == 'prev') {
      this.current -= 1;
      if (this.current == 0) {
        this.current = this.cantidad;
      }
    } else {
      this.current += 1;
      if (this.current > this.cantidad) {
        this.current = 1;
      }
    }
    this.data = this.archivos[this.current - 1];
  }

  loadfiles() {
    if (this.tpvInfo.idArchivo) {
      this.commerceService.getFileBilling({ id: this.tpvInfo.idArchivo || 0 })
        .then(result => {
          if (result) {
            this.mapobject(result);
          }
        })
    }
  }

  empty() {
    return this.cantidad == 0;
  }

  mapobject(item) {
    if (item) {      
      //console.log(item)
      this.cantidad += 1;
      this.archivos = [...this.archivos, { ...item, pdfUrl: this.domSanitizer.bypassSecurityTrustResourceUrl(item.url) }]
      this.data = item;
      this.current = this.cantidad;
    }
  }

  download() {
    if (this.data) {
      window.open(this.data.url, '_blank');
    }
  }


  onUploadOutput(output: UploadOutput): void {
    setTimeout(() => {
      if (output.file) {
        const type = output.file.type.length > 0 ? output.file.type.split('/')[1] : 'default';
  
        switch (type) {
          case 'pdf':
            this.fileIcon = 'file-pdf-o';
            break;
          case 'doc':
          case 'docx':
            this.fileIcon = 'file-word-o';
            break;
          case 'jpeg':
          case 'jpg':
          case 'png':
            this.fileIcon = 'file-image-o';
            break;
          default:
            this.fileIcon = 'file';
            break;
        }
      }
      if (output.type == 'uploading') {
        this.fileStatus = 'loading'
      }
      if (output.type == 'done') {
        //this.fileStatus = 'done-ms'
        setTimeout(() => {
          this.fileStatus = 'done'
        }, 5000);
        this.mapobject(output.file.response.object);
        this.onComplete.emit(output.file.response.object);
      }
      if (output.type === 'allAddedToQueue') { // when all files added in queue
        // uncomment this if you want to auto upload files when added
        const event: UploadInput = {
          type: 'uploadAll',
          url: CONFIG.url + 'file/savebilling',
          method: 'POST',
          //data: { type: 'Trash', parentID: ((this.userID || 1) + '') },
          data: { type: 'Trash', idArchivo: ((this.tpvInfo.idArchivo || 0) + ''), idBilling: ((this.tpvInfo.id || 0) + ''), idWizard: ((this.tpvInfo.idWizard || 0) + '')},
          concurrency: 0
        };
        this.uploadInput.emit(event);
      } 
      else if (output.type === 'addedToQueue') {
        this.files.push(output.file); // add file to array when added
      }
      else if (output.type === 'uploading') {
        // update current data in files array for uploading file
        const index = this.files.findIndex(file => file.id === output.file.id);
        this.files[index] = output.file;
      }
      else if (output.type === 'removed') {
        // remove file from array when removed
        this.files = this.files.filter((file: UploadFile) => file !== output.file);
      }
      else if (output.type === 'dragOver') { // drag over event
        this.dragOver = true;
      }
      else if (output.type === 'dragOut') { // drag out event
        this.dragOver = false;
      }
      else if (output.type === 'drop') { // on drop event
        this.dragOver = false;
      }
      
    }, 2000);
    
  }
  // startUpload(): void {  // manually start uploading
  //   const event: UploadInput = {
  //     type: 'uploadAll',
  //     url: CONFIG.url + 'file/save',
  //     method: 'POST',
  //     data: { type: 'Trash', parentID: '0' },
  //     concurrency: 1 // set sequential uploading of files with concurrency 1
  //   }

  //   this.uploadInput.emit(event);
  // }

  // cancelUpload(id: string): void {
  //   this.uploadInput.emit({ type: 'cancel', id: id });
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/component/core/uploader-billing/uploader-billing.component.ts